const Downloads = {

  methods: {
    downloadFile(filename, dataurl) {
      var element = document.createElement('a')
      element.setAttribute('href', dataurl)
      element.setAttribute('download', filename)
      element.style.display = 'none'
      document.body.appendChild(element)
      element.click()
      document.body.removeChild(element)
      window.URL.revokeObjectURL(dataurl)
    }
  }
}

export default Downloads